<template>
    <div class="pics">
        <van-image fit="cover" @click="previewImage(index)" class="pic" v-for="(img,index) in imgs" :key="index" :src="img"/>
    </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
   name: 'CommentPic',
   data() {
       return {
           previewInstance: null,
           previewClickHandler: null
       }
   },
   props: {
       urls:{
           type: Array,
           default: () => {
               return []
           }
       }
   },
   computed: {
       imgs() {
           let imgs = []
           imgs = this.urls.map(item=>{
               item.replace('https://cdn-xcx-qunsou.weiyoubot.cn', 'https://image.xiaoqiandao.com') + '?imageMogr2/crop/500x500/gravity/northwest/thumbnail/300x300';
               return item
           })
           return imgs
       }
   },
   methods: {
       isPreviewMaskTarget(target) {
           if (!target || !target.classList) {
               return false
           }
           if (
               target.classList.contains('van-image-preview') ||
               target.classList.contains('van-image-preview__swipe') ||
               target.classList.contains('van-image-preview__swipe-item')
           ) {
               return true
           }
           return false
       },
       bindPreviewMaskClose(instance) {
           this.unbindPreviewMaskClose()
           if (!instance || !instance.$el) {
               return
           }
           this.previewInstance = instance
           this.previewClickHandler = (event) => {
               const target = event.target
               if (!instance.value) {
                   return
               }
               if (this.isPreviewMaskTarget(target)) {
                   instance.close()
               }
           }
           instance.$el.addEventListener('click', this.previewClickHandler, true)
           instance.$once('closed', () => {
               this.unbindPreviewMaskClose()
           })
       },
       unbindPreviewMaskClose() {
           if (this.previewInstance && this.previewInstance.$el && this.previewClickHandler) {
               this.previewInstance.$el.removeEventListener('click', this.previewClickHandler, true)
           }
           this.previewInstance = null
           this.previewClickHandler = null
       },
       previewImage(index) {
           const instance = ImagePreview({
               images: this.urls,
               startPosition: index,
               closeOnClickOverlay: true,
               closeOnPopstate: true,
               closeable: true
           })
           this.bindPreviewMaskClose(instance)
       }
   },
   beforeDestroy() {
       this.unbindPreviewMaskClose()
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.pics {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.pic {
    width: rem(150);
    height: rem(150);
    margin-right: rem(16);
    margin-bottom: rem(16);
    border-radius: rem(8);
}
</style>


// WEBPACK FOOTER //
// src/components/CommentPic.vue